/**
 * Esta diretiva serve para evitar redirecionar o clique
 * Sua maior utilidade é para utilizar botões customizados para enviar arquivos,
 *  Exemplo de uso:
 *  <input type="file" id="myFile" v-model="file" style="display: none/>
 *  <button type="button" v-click-redirect="myFile">UPLOAD FILE</button>
 */

export default {
  name: 's-trigger',
  install(Vue) {
    Vue.directive('click-redirect', {
      bind: (el, binding) => {
        el.addEventListener('click', () => {
          const { value } = binding;
          const targetElement = document.getElementById(value);
          if (!targetElement) return;
          targetElement.click();
        });
      },
    });
  },
};
